import { DocsEntityConfiguration } from "./SDKDocsEntityConfiguration";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var DocsEntityDraftChangeType;
(function (DocsEntityDraftChangeType) {
    DocsEntityDraftChangeType["Updated"] = "Updated";
    DocsEntityDraftChangeType["Created"] = "Created";
    DocsEntityDraftChangeType["Deleted"] = "Deleted";
})(DocsEntityDraftChangeType || (DocsEntityDraftChangeType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityDraftState {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        this.changeType = model.changeType;
        if (model.changeType === "Updated") {
            this.previousTitle = (_a = model.changes.previousTitle) !== null && _a !== void 0 ? _a : null;
            this.previousConfiguration = model.changes.previousConfiguration
                ? new DocsEntityConfiguration(model.changes.previousConfiguration, (_b = this.previousTitle) !== null && _b !== void 0 ? _b : "")
                : null;
            this.previousContentHash = (_c = model.changes.previousContentHash) !== null && _c !== void 0 ? _c : null;
        }
        else {
            this.previousTitle = null;
            this.previousConfiguration = null;
            this.previousContentHash = null;
        }
    }
}
